export class LogoutError extends Error {
	constructor() {
		super("Error during logout");
	}
}
